module.exports = __webpack_public_path__ + "static/media/greetings-bg.49b92354.jpg";